import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Paragraph, Text } from "components/core/Typography";

import "./FormField.scss";

// FormField = LaellWrapper + Input
export const LabelWrapper = ({
	children,
	isDirty,
	isTouched,
	invalid,
	error,
	htmlFor,
	type,
	required,
	icon,
	label,
	helpText,
	errorMessage
}) => (
	<label
		htmlFor={htmlFor}
		className={classNames(
			"label-wrapper",
			{ [`type-${type}`]: type },
			{
				dirty: isDirty,
				touched: isTouched,
				invalid,
				error
			},
		)}
	>
		{children}
		{/* the label comes after the input to allow the ~ selector to work */}
		<Text
			color="darkGray"
			className="label-text"
		>
			{/* optionally include an icon by the label name */}
			{!!icon && <span className="icon">{icon}</span>}
			{/* the label title */}
			{label}
			{/*  an asterisk if the input is required */}
			{!!required && <span className="required"> *</span>}
		</Text>
		{!!error && <Paragraph last size="tiny" className="error-text">{errorMessage || error.message}</Paragraph>}
		{!!helpText && <Paragraph last size="tiny" className="help-text">{helpText}</Paragraph>}
	</label >
);

// in order of wrapper props
LabelWrapper.propTypes = {
	children: PropTypes.node,
	// rhf field status props
	isDirty: PropTypes.bool,
	isTouched: PropTypes.bool,
	invalid: PropTypes.bool,
	error: PropTypes.object,
	// label props
	errorMessage: PropTypes.string,
	htmlFor: PropTypes.string.isRequired,
	type: PropTypes.string,
	required: PropTypes.bool,
	icon: PropTypes.node,
	label: PropTypes.node,
	helpText: PropTypes.string
};